export default __webpack_public_path__ + "static/media/blueCircleEarthLogo.85bccbb4.svg";